import { useEffect } from 'react';
import { useMutation } from '@apollo/client';


import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { useLoadingAnimation } from '@/components/LoadingAnimation/useLoadingAnimation.hook';

import { notificationService } from '@/services/notification/notification.client';

import CreateExportJobMutation from '@/graphql/contracts/createExportJob.mutation.gql';
import { ExportInput } from '@/graphql/contracts/_generated_/contracts';

import useExportUsageDetailsFile from './useExportUsageDetailsFile';
import { CreateExportJob, CreateExportJobVariables } from '@/graphql/contracts/_generated_/createExportJob.mutation';

export default function useExport() {
  const { toggleLoadingAnimation } = useLoadingAnimation();
  const { downloadAndRetry, fileIsLoading, setFileIsLoading } = useExportUsageDetailsFile();
  const [_createExportJob, { loading, called }] = useMutation<CreateExportJob, CreateExportJobVariables>(
    CreateExportJobMutation,
    {
      client: apolloClientContracts,
      onError: (err) => {
        setFileIsLoading(false);
        notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        });
      },
    },
  );

  const exportUsageDetails = async (usageDetails: ExportInput, fileName: string) => {
    const exportResponse = await _createExportJob({
      variables: { input: usageDetails },
    });
    const exportJob = exportResponse?.data?.general?.exportJobs?.createExportJob;

    if (exportJob?.__typename === 'ExportRequestReceipt') {
      downloadAndRetry(exportJob.id, fileName);
    }
  };

  useEffect(() => {
    if (called) toggleLoadingAnimation(fileIsLoading);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileIsLoading, called]);

  return {
    exportUsageDetails,
    isLoadingExportJob: loading
  } as const;
}
